import { GridFilterSettingsRealTimeData } from '../../../../../../generated/signalR/grid-filter-settings-real-time-data';
import { IGridFilterItem } from '../../../../../samwebDescription/samweb/filters/IGridFilterItem';
import { LongRunningContextCategoryTyp } from '../../../../../samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningAction } from '../../../../server-communication/running-actions/types/longRunningAction.decorator';
import { IBrickInstanceTargetingAction } from '../../../../utility/IBrickInstanceTargetingAction';

export class GridFilterSettingsChanged implements IBrickInstanceTargetingAction {
   public static readonly type = '[GridFilterState] Settings changed';

   constructor(public selection: IGridFilterItem, public isSelected: boolean, public brickInstanceId: string, public gridId: string, public filterId: string) {}
}

export class GridFilterSettingsUpdatedByServer {
   public static readonly type = '[GridFilterState] Settings updated by server';

   constructor(public data: GridFilterSettingsRealTimeData) {}
}

export class ToggleFilterPopup implements IBrickInstanceTargetingAction {
   public static readonly type = '[GridFilterState] toggle filter popup';

   constructor(public brickInstanceId: string, public gridId: string, public filterId: string) {}
}

export class FilterItemsCleared implements IBrickInstanceTargetingAction {
   public static readonly type = '[GridFilterState] clear filter items';

   constructor(public brickInstanceId: string, public gridId: string) {}
}

export class StartToPersistAllGridFilterSettings implements IBrickInstanceTargetingAction {
   public static readonly type = '[GridFilterState] start to persist all grid filter settings';

   constructor(public brickInstanceId: string) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.GRID_FILTERS)
export class PersistGridFilterSettings implements IBrickInstanceTargetingAction {
   public static readonly type = '[GridFilterState] persist grid filter settings';

   constructor(public brickInstanceId: string) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.GRID_FILTERS)
export class PersistAllGridFilterSettings {
   public static readonly type = '[GridFilterState] persist all grid filter settings';

   constructor(public brickInstanceIds: string[]) {}
}
